import type { AxiosError } from '@ahm/api-wrappers-core';
import {
  QueryClient,
  type DefaultOptions,
  type UseMutationOptions,
  type UseQueryOptions,
} from '@tanstack/react-query';

export type ExtractFnReturnType<FnType extends () => any> = ReturnType<FnType>;

export type QueryConfig<QueryFnType extends () => any> = Omit<
  UseQueryOptions<ExtractFnReturnType<QueryFnType>>,
  'queryKey' | 'queryFn' | 'select'
>;

export type MutationConfig<MutationFnType extends () => any> =
  UseMutationOptions<
    ExtractFnReturnType<MutationFnType>,
    AxiosError,
    Parameters<MutationFnType>[0]
  >;

// const onError = (e: unknown) => {
//   const errorCode = (e as DefaultQueryError).response?.data.code.toString();
//   switch (errorCode) {
//     case ErrorCode.NotAuthorized:
//     case ErrorCode.TokenNotFound:
//     case ErrorCode.RefreshTokenHasExpired:
//     case ErrorCode.WrongPasscode:
//     case ErrorCode.WrongOtp:
//     case ErrorCode.UserNotFound:
//     case String(ERROR_CODE_OPSTECH.RECORD_NOT_FOUND.code):
//       return;

//     default:
//       const errorMessage =
//         (e as DefaultQueryError).response?.data.description ||
//         (e as DefaultQueryError).response?.data.title ||
//         (e as Error).message;

//       toast.error(errorMessage);

//       console.log('onError', errorMessage);
//   }
// };

// Differentiated cache strategies by data type
export const CACHE_STRATEGIES = {
  // Static data: categories, banners (rarely change)
  static: {
    staleTime: 30 * 60 * 1000, // 30 minutes
    gcTime: 60 * 60 * 1000, // 60 minutes
  },
  // Dynamic data: stores, deals (change moderately)
  dynamic: {
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  },
  // Real-time data: deal progress, availability (changes frequently)
  realtime: {
    staleTime: 1 * 60 * 1000, // 1 minute
    gcTime: 5 * 60 * 1000, // 5 minutes
  },
};

const staleTime = CACHE_STRATEGIES.dynamic.staleTime; // Default: 5 minutes
const gcTime = CACHE_STRATEGIES.dynamic.gcTime; // Default: 10 minutes

const queryConfig: DefaultOptions = {
  mutations: {
    // onError,
  },
  queries: {
    retry: 1, // Retry once on failure for better UX
    retryOnMount: false, // Don't retry on mount if we have cached data
    refetchOnWindowFocus: false, // Don't refetch on window focus
    refetchOnReconnect: false, // Don't refetch on reconnect if data is fresh
    refetchOnMount: false, // CRITICAL: Don't refetch if we have cached data
    staleTime, // 5 minutes - data is considered fresh
    gcTime, // 10 minutes - keep unused data in cache for quick back navigation
    // onError,
  },
};

export const queryClient = new QueryClient({ defaultOptions: queryConfig });
